import React from 'react';

interface CustomErrorBoundaryProps {
    render: (error: Error | null) => React.ReactNode;
    children?: React.ReactNode;
}

export class CustomErrorBoundary extends React.Component<CustomErrorBoundaryProps, { error: Error | null }> {
    constructor(props: CustomErrorBoundaryProps) {
        super(props);

        this.state = {
            error: null
        };
    }

    static getDerivedStateFromError(error: any) {
        return { error };
    }

    render() {
        if (this.state.error) {
            return this.props.render(this.state.error);
        }

        return this.props.children;
    }
}
